import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

const firebase = require("firebase/app");
require("firebase/auth");
require("firebase/performance");


const firebaseConfig = require("./plugins/firebaseConfig.js");

import "./stylus/main.styl";
import "./stylus/main.sass";

//To remove in ./stylus/main.styl
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

// MAP
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBH_SjUzOntsJimmUMAYetw8lrW26htl_g",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

Vue.config.productionTip = false;
firebase.initializeApp(firebaseConfig.config);
firebase.performance();
// AUTH
firebase.auth().useDeviceLanguage();
firebase.auth().onAuthStateChanged(function(user) {
  store.dispatch("likeModule/fetchLikes");
  if (user) {
    store.dispatch("userModule/fetchUser", user.uid);
  } else {
    store.commit("userModule/CLEAR_USER");
  }
});

import FactoryComponent from "./components/HomeSections/FactoryComponent";
Vue.component("FactoryComponent", FactoryComponent);
import CText from "./components/HomeSections/SubComponents/Text";
Vue.component("CText", CText);

Vue.prototype.redirect = (name) => {
  if (name && name != null) {
    router.push({ name: name }).catch((err) => {
      if (err.name != "NavigationDuplicated")
        console.error(err.name + ":", err.message);
    });
  }
};

Vue.prototype.ismobile = () => {
  return window.innerWidth < 910;
};

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
